import React, { useRef, useState, useEffect } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import PropTypes from "prop-types";
import ExportCountReport from "../../../ExportData/components/ExportReports/component/CountReport";
import ScriptRunningReport from "../../../ExportData/components/ExportReports/component/ScriptRunningReport";
import DomainEspExportReportTrend from "../domain-esp-export-report-trend";

const ExportReport = () => {
  const [value, setValue] = useState(0);
  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box sx={{ width: "100%", padding: "10px" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Export Count Report" />
          <Tab label="ESP Source/Domain Wise Trend" />
          <Tab label="Script Running Report" />
          <Tab label="Export Checker" />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <ExportCountReport />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <DomainEspExportReportTrend/>
        {/* <Box
          pt={2}
          sx={{
            width: "100%  ",
            height: "100vh",
          }}
        >
          <iframe
            width={"100%"}
            height={"100%"}
            scrolling="no"
            frameBorder="0"
            src="https://reports.whatthestats.com/baec3e5e-5457-4d80-81c2-b0e0df129b74/4c0a48d7-0cd0-4d13-8b82-7cfdc1097d20"
          ></iframe>
        </Box> */}
      </TabPanel>
      <TabPanel value={value} index={2}>
        <ScriptRunningReport />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Box
          pt={2}
          sx={{
            width: "100%  ",
            height: "100vh",
          }}
        >
          <iframe
            width={"100%"}
            height={"100%"}
            scrolling="no"
            frameBorder="0"
            src="https://reports.whatthestats.com/baec3e5e-5457-4d80-81c2-b0e0df129b74/a6f863bd-10f8-4fb4-b823-438d1d8c31e4/all/0/0"
          ></iframe>
        </Box>
      </TabPanel>
    </Box>
  );
};
export default ExportReport;
